import {createAction} from "@reduxjs/toolkit";

export const setInfoPageSource = createAction('SET_INFO_PAGE_SOURCE');